import type { Workspace } from '@/features/iam/workspaces/Workspace'
import { env } from '@/infra/env'
import { sessionStorage } from '@/infra/storage'

const StripeConnectCodeStorageKey = 'worklayer.stripeConnectHandlerParams'

interface StripeConnectCodeParams {
  code: string
}

/**
 * Sends the browser to Stripe to connect a payout account for the workspace.
 */
export function redirectToStripeConnect(workspace: Workspace) {
  const ROOT = `${window.location.protocol}//${window.location.host}/callback/stripe-connect`
  window.location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${
    workspace.config.billing.stripeConnectId || env.STRIPE_CONNECT_ID
  }&scope=read_write&redirect_uri=${ROOT}`
}

/**
 * Stores the code Stripe redirected back with, so the payout method page can
 * finish the connection.
 */
export function setPendingStripeConnectCode(code: string) {
  const params: StripeConnectCodeParams = { code }
  sessionStorage.setItem(StripeConnectCodeStorageKey, JSON.stringify(params))
}

/**
 * Whether a Stripe Connect code is stored.
 */
export function hasPendingStripeConnectCode() {
  return sessionStorage.getItem(StripeConnectCodeStorageKey) !== null
}

/**
 * Takes the stored Stripe Connect code out of storage.
 */
export function takePendingStripeConnectCode() {
  const blob = sessionStorage.getItem(StripeConnectCodeStorageKey)
  sessionStorage.removeItem(StripeConnectCodeStorageKey)
  if (!blob) {
    throw new Error('Could not find callback params in session storage')
  }

  return (JSON.parse(blob) as StripeConnectCodeParams).code
}
